import {
  AttachFile,
  Chat,
  Check,
  Dashboard,
  DoneAll,
  EditNotifications,
  Email,
  HourglassBottom,
  Image,
  MiscellaneousServices,
  MonitorHeart,
  Pending,
  People,
  Person,
  Phone,
  PhoneIphone,
  PriorityHigh,
  Sms,
  ThumbDown,
  ThumbUp,
  Tune,
  AccountCircle,
  VerifiedUser,
  EventAvailable,
  DirectionsCar,
  TwoWheeler,
  LocalShipping,
  BusAlert,
  AirlineSeatIndividualSuite,
} from "@mui/icons-material";
import { localUrlEnum, pathParams } from "./UrlEnum";
import PageNotFound from "../Components/PageNotFound";
import { Vocabulary } from "./Vocabulary";
import PrivateRoute from "../Router/PrivateRouter";
import DashboardContainer from "../Components/DashboardContainer";
import Login from "../Pages/LoginPage";
import StatisticsPage from "../Pages/Statistics";
import SettingsIcon from "@mui/icons-material/Settings";
import ChecklistIcon from "@mui/icons-material/Checklist";
import { createTheme } from "@mui/material";
import {
  EAuditAction,
  EAuditStatus,
  EHeaderTemplateMenuOptions,
  ETemplateStatus,
  EWhatsAppComponentsTypes,
  EWhatsAppMessageType,
  EWhatsAppTemplateButtonType,
  EWhatsAppTemplateCategoryTranslation,
} from "./Enums";
import PhoneNumberRegistrationStep from "../Components/WhatsAppIntegration/PhoneNumberRegistrationStep";
import VerifyCodeConfirmationStep from "../Components/WhatsAppIntegration/VerifyCodeConfirmationStep";
import TwoFactorAuthenticationSetupStep from "../Components/WhatsAppIntegration/TwoFactorAuthenticationSetupStep";
import CoursesPage from "../Components/Courses/CoursesPage";
import Questionnaire from "../Components/Questionnaire/Questionnaire";
import ExamPage from "../Components/Questionnaire/ExamPage";
import ClientAccount from "../Components/ClientAccount/ClientAccount";
import LiveLegislation from "../Components/LiveLegislation/LiveLegislation";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import BackspaceIcon from "@mui/icons-material/Backspace";
import CommonWrongQuestions from "../Components/CommonWrongQuestions.tsx/CommonWrongQuestions";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import PublicRegistration from "../Components/PublicRegistration/PublicRegistration";
import PaymentStatusPage from "../Components/PublicRegistration/PaymentStatusPage";
import CertificateExams from "../Components/CertificateExams/CertificateExams";
import DrivingSessionScheduling from "../Components/DrivingSessionScheduling/DrivingSessionScheduling";
import ChatModal from "../Components/ChatModal/ChatModal";
import ChooseExamSimulation from "../Components/Questionnaire/ChooseExamSimulation";
import SimulateExam from "../Components/Questionnaire/SimulateExam";
import ClientRegistrationPage from "../Components/ClientRegistration/ClientRegistrationPage";
import SubscriptionExpiredPage from "../Components/PublicRegistration/SubscriptionExpiredPage";

export const disableTostify = "?disableTostify";

/**
 * Feature flag: Skip payment redirect if subscription/order amount is 0
 * Set to `true` to bypass payment when amount is 0
 * Set to `false` to require payment even for 0 amounts
 *
 * When enabled and amount is 0:
 * - Users will be redirected directly to their destination without payment
 * - Logged-in users → /client-account
 * - New users → /payment-status (which will proceed with account activation)
 */
export const SKIP_PAYMENT_IF_ZERO_AMOUNT = true;

export const HttpStatusCode = {
  OK: 200,
  Created: 201,
  Accepted: 202,
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  RequestTimeout: 408,
  InternalServerError: 500,
  NotImplemented: 501,
  UnprocessableEntity: 422,
  Conflict: 409,
};

export const resourcePaths = {
  tasks: "/tasks",
};

export const HttpVerbs = {
  post: "post",
  get: "get",
  put: "put",
  delete: "delete",
  patch: "patch",
};

export const SortOptions = {
  asc: "asc",
  desc: "desc",
};

export const WhatsAppMenuItems = [
  {
    name: Vocabulary.phoneNumber,
    path: localUrlEnum.whatsAppPhoneNumbers,
    icon: <PhoneIphone />,
  },
  {
    name: Vocabulary.templates,
    path: localUrlEnum.whatsAppTemplates,
    icon: <Chat />,
  },
];

export const MainSliderData = [
  {
    name: Vocabulary.statistics,
    path: localUrlEnum.statistics,
    icon: <ShowChartIcon />,
  },

  {
    name: Vocabulary.tools,
    path: "",
    icon: <Tune />,
    children: [
      {
        name: Vocabulary.users,
        path: localUrlEnum.users,
        icon: <People />,
      },
      {
        name: Vocabulary.ordersStatuses,
        path: localUrlEnum.orderStatus,
        icon: <ChecklistIcon />,
      },
      {
        name: Vocabulary.alerts,
        path: localUrlEnum.alerts,
        icon: <EditNotifications />,
      },
      {
        name: Vocabulary.logs,
        path: localUrlEnum.logs,
        icon: <MonitorHeart />,
      },
      {
        name: Vocabulary.settings,
        path: localUrlEnum.settings,
        icon: <SettingsIcon />,
      },
    ],
  },
];

export const MainSliderDataForUser = [
  {
    name: Vocabulary.clientAccount,
    path: localUrlEnum.clientAccount,
    icon: <AccountCircle />,
  },
  {
    name: Vocabulary.statistics,
    path: localUrlEnum.statistics,
    icon: <ShowChartIcon />,
  },
  {
    name: Vocabulary.questionnaire,
    path: localUrlEnum.questionnaire,
    icon: <Dashboard />,
  },
  {
    name: Vocabulary.simulateExam,
    path: localUrlEnum.simulateExam,
    icon: <PendingActionsIcon />,
  },
  {
    name: Vocabulary.liveLegislation,
    path: localUrlEnum.liveLegislation,
    icon: <LiveTvIcon />,
  },
  {
    name: Vocabulary.commonWrongQuestions,
    path: localUrlEnum.commonWrongQuestions,
    icon: <BackspaceIcon />,
  },
  {
    name: Vocabulary.drivingSessionScheduling,
    path: localUrlEnum.drivingSessionScheduling,
    icon: <EventAvailable />,
  },
];

export const MainSliderDataForCertificateHolder = [
  {
    name: Vocabulary.clientAccount,
    path: localUrlEnum.clientAccount,
    icon: <AccountCircle />,
  },
  {
    name: Vocabulary.statistics,
    path: localUrlEnum.statistics,
    icon: <ShowChartIcon />,
  },
  {
    name: Vocabulary.questionnaire,
    path: localUrlEnum.questionnaire,
    icon: <Dashboard />,
  },
  {
    name: Vocabulary.simulateExam,
    path: localUrlEnum.simulateExam,
    icon: <PendingActionsIcon />,
  },
  {
    name: Vocabulary.liveLegislation,
    path: localUrlEnum.liveLegislation,
    icon: <LiveTvIcon />,
  },
  {
    name: Vocabulary.certificateExams,
    path: localUrlEnum.certificateExams,
    icon: <VerifiedUser />,
  },
  {
    name: Vocabulary.commonWrongQuestions,
    path: localUrlEnum.commonWrongQuestions,
    icon: <BackspaceIcon />,
  },
  {
    name: Vocabulary.drivingSessionScheduling,
    path: localUrlEnum.drivingSessionScheduling,
    icon: <EventAvailable />,
  },
];

export const ClientExcelHeader = [
  "CLIENT",
  "CATEGORIE",
  "SAPTAMANA",
  "COD_FISCAL",
  "NR_REGISTRU_COMERT",
  "OBSERVATII",
  "ADRESA",
  "ORAS",
  "JUDET",
  "BANCA",
  "CONT_BANCAR",
  "TARA",
  "EMAIL",
  "PERSOANA_DE_CONTACT",
  "TELEFON",
];

export const ROLES = {
  ROLE_ADMINISTRATOR: "ROLE_ADMINISTRATOR",
  ROLE_USER: "ROLE_USER",
  ROLE_CERTIFICATE_HOLDER: "ROLE_CERTIFICATE_HOLDER",
};

export const ROLE_UI_NAMES = {
  USER: "User",
  CERTIFICATE_HOLDER: "CertificateHolder",
  ADMINISTRATOR: "Administrator",
};

export const PAYMENT_TYPES = {
  SUBSCRIPTION_CREATED: "subscription_created",
  SUBSCRIPTION_RENEWAL: "subscription_renewal",
  SCHOOL_ENROLLING: "school_enrolling",
  SCHOOL_PAYMENTS: "school_payments",
  SUPPLEMENTARY_HOURS: "supplementary_hours",
};

export const ComponentsNames = {
  MainSlider: "MainSlider",
  LocalRouter: "LocalRouter",
  MainHeader: "MainHeader",
  ContactsTable: "ContactsTable",
  Task: "Task",
  FileExplorerMin: "FileExplorerMin",
};

export const SubtaskColumns = [
  {
    label: Vocabulary.fancyName,
    name: "text",
  },
  {
    label: Vocabulary.status,
    name: "status",
  },
];

export const EXCLUDE_ROUTES_FROM_LOGIN_REDIRECT = [
  localUrlEnum.publicRegistration,
  localUrlEnum.paymentStatus,
  localUrlEnum.resetPassword,
  localUrlEnum.forgotPassword,
  localUrlEnum.clientRegistration,
];

export const AllRoutes = [
  { path: localUrlEnum.login, element: <Login /> },
  { path: localUrlEnum.publicRegistration, element: <PublicRegistration /> },
  {
    path: localUrlEnum.clientRegistration,
    element: <ClientRegistrationPage />,
  },
  { path: localUrlEnum.paymentStatus, element: <PaymentStatusPage /> },
  {
    path: localUrlEnum.subscriptionExpired,
    element: <SubscriptionExpiredPage />,
  },
  {
    path: localUrlEnum.mainRoute,
    element: (
      <PrivateRoute>
        <DashboardContainer />
        <ChatModal />
      </PrivateRoute>
    ),
    children: [
      {
        path: localUrlEnum.mainRoute,
        element: <ClientAccount />,
      },
      {
        path: localUrlEnum.clientAccount,
        element: <ClientAccount />,
      },
      {
        path: localUrlEnum.statistics,
        element: <StatisticsPage shouldRenderSearchBar={false} />,
      },
      {
        path: localUrlEnum.drivingSessionScheduling,
        element: <DrivingSessionScheduling />,
      },
      {
        path: `${localUrlEnum.courses}${pathParams.courseId}`,
        element: <CoursesPage />,
      },
      {
        path: localUrlEnum.questionnaire,
        element: <Questionnaire />,
      },
      {
        path: localUrlEnum.examQuestions,
        element: <ExamPage />,
      },
      {
        path: `${localUrlEnum.examQuestions}${pathParams.examSetId}`,
        element: <ExamPage />,
      },
      {
        path: localUrlEnum.simulateExam,
        element: <SimulateExam />,
      },
      {
        path: localUrlEnum.liveLegislation,
        element: <LiveLegislation />,
      },
      {
        path: localUrlEnum.commonWrongQuestions,
        element: <CommonWrongQuestions />,
      },
      {
        path: localUrlEnum.certificateExams,
        element: <CertificateExams />,
      },
      {
        path: localUrlEnum.chooseExamsSimulation,
        element: <ChooseExamSimulation />,
      },
    ],
  },
  {
    path: localUrlEnum.pageNotFound,
    element: <PageNotFound text={Vocabulary.pageNotFound} />,
  },
];

export const HeaderTemplateMenuOptions = [
  { label: "Fără", value: EHeaderTemplateMenuOptions.NONE },
  { label: "Text", value: EHeaderTemplateMenuOptions.TEXT },
  { label: "Imagine", value: EHeaderTemplateMenuOptions.IMAGE },
  { label: "Video", value: EHeaderTemplateMenuOptions.VIDEO },
  { label: "Document", value: EHeaderTemplateMenuOptions.DOCUMENT },
];

const UserRouter = {
  routes: [
    localUrlEnum.login,
    localUrlEnum.mainRoute,
    localUrlEnum.pageNotFound,
    localUrlEnum.clientAccount,
    localUrlEnum.statistics,
    localUrlEnum.drivingSessionScheduling,
    localUrlEnum.clients,
    `${localUrlEnum.client}${pathParams.optionalId}`,
    localUrlEnum.paymentStatus,
    `${localUrlEnum.orderOfferPasswordCheck}${pathParams.orderId}`,
    `${localUrlEnum.orderOffer}${pathParams.orderId}`,
    `${localUrlEnum.orderOfferConfirmation}${pathParams.orderId}`,
    localUrlEnum.products,
    localUrlEnum.orders,
    localUrlEnum.tasks,
    `${localUrlEnum.order}${pathParams.optionalId}`,
    `${localUrlEnum.product}${pathParams.optionalId}`,
    localUrlEnum.emailTemplates,
    localUrlEnum.whatsAppPhoneNumbers,
    localUrlEnum.whatsAppTemplates,
    `${localUrlEnum.whatsAppTemplate}${pathParams.optionalId}`,
    localUrlEnum.renderChildren,
    `${localUrlEnum.messages}${pathParams.optionalId}`,
    localUrlEnum.examQuestions,
    `${localUrlEnum.examQuestions}${pathParams.examSetId}`,
    localUrlEnum.liveLegislation,
    localUrlEnum.simulateExam,
    `${localUrlEnum.courses}${pathParams.courseId}`,
    localUrlEnum.questionnaire,
    localUrlEnum.commonWrongQuestions,
    localUrlEnum.chooseExamsSimulation,
    localUrlEnum.chooseExamProduct,
    localUrlEnum.publicRegistration,
    localUrlEnum.clientRegistration,
    localUrlEnum.purchaseAddons,
    localUrlEnum.subscriptionExpired,
  ],
};

const CertificateHolderRouter = {
  routes: [
    localUrlEnum.login,
    localUrlEnum.mainRoute,
    localUrlEnum.pageNotFound,
    localUrlEnum.clientAccount,
    localUrlEnum.statistics,
    localUrlEnum.drivingSessionScheduling,
    localUrlEnum.clients,
    `${localUrlEnum.client}${pathParams.optionalId}`,
    localUrlEnum.paymentStatus,
    `${localUrlEnum.orderOfferPasswordCheck}${pathParams.orderId}`,
    `${localUrlEnum.orderOffer}${pathParams.orderId}`,
    `${localUrlEnum.orderOfferConfirmation}${pathParams.orderId}`,
    localUrlEnum.products,
    localUrlEnum.orders,
    localUrlEnum.tasks,
    `${localUrlEnum.order}${pathParams.optionalId}`,
    `${localUrlEnum.product}${pathParams.optionalId}`,
    localUrlEnum.emailTemplates,
    localUrlEnum.whatsAppPhoneNumbers,
    localUrlEnum.whatsAppTemplates,
    `${localUrlEnum.whatsAppTemplate}${pathParams.optionalId}`,
    localUrlEnum.renderChildren,
    `${localUrlEnum.messages}${pathParams.optionalId}`,
    localUrlEnum.examQuestions,
    `${localUrlEnum.examQuestions}${pathParams.examSetId}`,
    localUrlEnum.liveLegislation,
    localUrlEnum.simulateExam,
    localUrlEnum.certificateExams,
    `${localUrlEnum.courses}${pathParams.courseId}`,
    localUrlEnum.questionnaire,
    localUrlEnum.commonWrongQuestions,
    localUrlEnum.chooseExamsSimulation,
    localUrlEnum.chooseExamProduct,
    localUrlEnum.publicRegistration,
    localUrlEnum.clientRegistration,
    localUrlEnum.purchaseAddons,
    localUrlEnum.subscriptionExpired,
  ],
};

export const RoleUI: { [key: string]: any } = {
  [ROLE_UI_NAMES.USER]: {
    MainSlider: {
      data: MainSliderDataForUser,
    },
    ContactsTable: {
      hideOptions: true,
    },
    LocalRouter: UserRouter,
  },
  [ROLE_UI_NAMES.CERTIFICATE_HOLDER]: {
    MainSlider: {
      data: MainSliderDataForCertificateHolder,
    },
    ContactsTable: {
      hideOptions: true,
    },
    LocalRouter: CertificateHolderRouter,
  },
  Abonament: {
    MainSlider: {
      data: MainSliderDataForUser,
    },
    ContactsTable: {
      hideOptions: true,
    },
    LocalRouter: UserRouter,
  },
};

export const EWeekDays = [
  { name: "LUNI", value: 1 },
  { name: "MARTI", value: 2 },
  { name: "MIERCURI", value: 3 },
  { name: "JOI", value: 4 },
  { name: "VINERI", value: 5 },
  { name: "SAMBATA", value: 6 },
  { name: "DUMINICA", value: 0 },
];

export const emailTemplateAdditionalData = {
  "order.Number": "Număr comandă",
  "client.name": "Nume client",
  "client.email": "Email client",
};

/**
 * responsive design resolution breakpoints
 */
export const ResolutionBreakPoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
};

export const WhatsAppTemplateButtons = [
  {
    name: Vocabulary.quickReply,
    menu: [
      {
        name: Vocabulary.custom,
        content: {
          type: "QUICK_REPLY",
          text: "",
        },
      },
    ],
    shouldRenderDivider: true,
  },
  {
    name: Vocabulary.specificAction,
    menu: [
      {
        name: Vocabulary.visitSite,
        buttonNr: 2,
        content: {
          type: EWhatsAppTemplateButtonType.URL,
          text: "",
          url: "",
          example: [],
        },
      },
      {
        name: Vocabulary.callPhoneNumber,
        buttonNr: 1,
        content: {
          type: EWhatsAppTemplateButtonType.PHONE_NUMBER,
          text: "",
          phone_number: "",
        },
      },
    ],
  },
];

export const DefaultWhatsAppTemplateComponents = [
  {
    type: EWhatsAppComponentsTypes.HEADER,
    format: "NONE",
  },
  {
    type: EWhatsAppComponentsTypes.BODY,
    text: "",
  },
  {
    type: EWhatsAppComponentsTypes.FOOTER,
    text: "",
  },
  {
    type: EWhatsAppComponentsTypes.BUTTONS,
    buttons: [],
  },
];

export const WhatsappMessageStatuses: any = {
  sent: {
    name: "Trimis",
    icon: <Check fontSize="small" />,
  },
  delivered: {
    name: "Livrat",
    icon: <DoneAll fontSize="small" />,
  },
  read: {
    name: "Citit",
    icon: <DoneAll sx={{ color: "#2196f3" }} fontSize="small" />,
  },
  pending: {
    name: "În așteptare",
    icon: <HourglassBottom fontSize="small" />,
  },
  failed: {
    name: "Eșuat",
    icon: <PriorityHigh fontSize="small" />,
  },
};

export const IconsForNotes: any = {
  SYSTEM: {
    name: "SYSTEM",
    label: "System",
    icon: <SettingsIcon />,
    backgroundColor: "#3d6f6c",
  },
  EMAIL: {
    name: "EMAIL",
    label: "Email",
    icon: <Email />,
    backgroundColor: "#3d6f6c",
  },
  PHONE: {
    name: "PHONE",
    label: "Phone",
    icon: <Phone />,
    backgroundColor: "#3d6f6c",
  },
  SMS: {
    name: "SMS",
    label: "Sms",
    icon: <Sms />,
    backgroundColor: "#3d6f6c",
  },
  USER: {
    name: "USER",
    label: "User",
    icon: <Person />,
    backgroundColor: "#3d6f6c",
  },
  OTHERS: {
    name: "OTHERS",
    label: "Others",
    icon: <MiscellaneousServices />,
    backgroundColor: "#3d6f6c",
  },
};

export const WhatsAppTemplateStatuses: any = {
  APPROVED: ETemplateStatus.APPROVED,
  PENDING: ETemplateStatus.PENDING,
  REJECTED: ETemplateStatus.REJECTED,
};

export const WhatsAppTemplateIconsStatuses: any = {
  APPROVED: <ThumbUp />,
  PENDING: <Pending />,
  REJECTED: <ThumbDown />,
};

export const WhatsAppTemplateChipColors: any = {
  APPROVED: "#E1F0DA",
  PENDING: "#BED7DC",
  REJECTED: "#FF9B9B",
};

export const WhatsAppTemplateCategory: any = {
  AUTHENTICATION: EWhatsAppTemplateCategoryTranslation.AUTHENTICATION,
  MARKETING: EWhatsAppTemplateCategoryTranslation.MARKETING,
  UTILITY: EWhatsAppTemplateCategoryTranslation.UTILITY,
};

export const WhatsAppTemplatesSupportedLanguagesTranslation: any = {
  ro: "Română",
  en_US: "Engleză (US)",
  en_GB: "Engleză (GB)",
};

export const tableTheme: any = (defaultTheme: any) =>
  createTheme({
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            "&:after": {
              borderBottom: "2px solid #3d6f6c !important",
            },
          },
        },
      },
      MuiDialogTitle: {
        styleOverrides: {
          root: {
            backgroundColor: "#3d6f6c !important",
            color: "#fff !important",
          },
        },
      },

      MuiPaper: {
        styleOverrides: {
          root: {
            [defaultTheme.breakpoints.down("md")]: {
              // marginTop: 50,
            },
          },
        },
      },

      MuiButtonBase: {
        styleOverrides: {
          root: {
            [defaultTheme.breakpoints.down("md")]: {
              marginTop: 4,
            },
          },
        },
      },
      MUIDataTableToolbar: {
        styleOverrides: {
          actions: {
            display: "flex",
            flexDirection: "row-reverse",
          },
          root: {
            [defaultTheme.breakpoints.down("md")]: {
              borderTopLeftRadius: "0px !important",
              borderTopRightRadius: "0px !important",
              display: "flex",
              textAlign: "center",
              backgroundColor: "#ededef !important",
              zIndex: 200,
              padding: 10,
            },
          },
        },
      },

      MuiIconButton: {
        styleOverrides: {
          root: {
            "&:hover": {
              color: "#3d6f6c",
            },
          },
        },
      },
      MuiToolbar: {
        styleOverrides: {
          root: {
            backgroundColor: "rgb(64, 74, 105, 0.3)",
            borderTopRightRadius: "5px",
            borderTopLeftRadius: "5px",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            backgroundColor: "rgb(64, 74, 105, 0.1)",
            fontWeight: 800,
          },
          root: {
            padding: "7px !important",
            paddingLeft: "25px !important",
          },
        },
      },
      MuiTablePagination: {
        styleOverrides: {
          toolbar: {
            backgroundColor: "#FFF",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            backgroundColor: "#FFF",
            color: "#000",
            borderRadius: "50px",
            "&:hover": {
              backgroundColor: "#fff",
              color: "#3d6f6c",
            },
            [defaultTheme.breakpoints.down("md")]: {
              marginTop: 5,
            },
          },
        },
      },
    },
  });

export const WhatsAppTemplatesSupportedLanguages = ["ro", "en_US", "en_GB"];

export const FormsIds = {
  phoneNumber: "phoneNumber",
  verifyCodeForm: "verifyCodeForm",
  twoFactorAuthentication: "twoFactorAuthentication",
  importClientsForm: "importClientsForm",
  clients: "clients",
  clientsCategory: "clientsCategory",
  contactEmailForm: "contactEmailForm",
  billingDocumentsForm: "billingDocumentsForm",
  orderForm: "orderForm",
  orderSettingsNumber: "orderSettingsNumber",
  editOrderSettings: "editOrderSettings",
  usersForm: "usersForm",
  orderOfferForm: "orderOfferForm",
  editEmailTemplateForm: "editEmailTemplateForm",
  whatsAppTemplateForm: "whatsAppTemplateForm",
  whatsAppSettingsForm: "whatsAppSettingsForm",
  chatListForm: "chatListForm",
  noteForm: "noteForm",
  taskForm: "taskForm",
  alertForm: "alertForm",
};

export const TablesIds = {
  logs: "logs",
  orders: "orders",
  clients: "clients",
  products: "products",
  emailTemplates: "emailTemplates",
  users: "users",
  contacts: "contacts",
  clientCategories: "clientCategories",
  tasks: "tasks",
  alerts: "alerts",
};

export const RegisterWhatsAppPhoneNumberSteps = [
  {
    label: Vocabulary.registerPhoneNumber,
    component: <PhoneNumberRegistrationStep />,
    formName: FormsIds.phoneNumber,
  },
  {
    label: Vocabulary.verifyPhoneNumberRegistrationCode,
    component: <VerifyCodeConfirmationStep />,
    formName: FormsIds.verifyCodeForm,
  },
  {
    label: Vocabulary.setPinForTwoStepVerification,
    component: <TwoFactorAuthenticationSetupStep />,
    formName: FormsIds.twoFactorAuthentication,
  },
];

export const WhatsAppTemplatePropertyTags = [
  { label: "Nume client", value: "name" },
  { label: "Total comandă", value: "total" },
  { label: "Număr comandă", value: "number" },
  { label: "Link comandă", value: "orderLink" },
  { label: "Parolă", value: "password" },
  {
    label: "Nume persoană de contact",
    value: "contactPerson.firstName",
  },
  {
    label: "Prenume persoană de contact",
    value: "contactPerson.lastName",
  },
  {
    label: "Email persoană de contact",
    value: "contactPerson.email",
  },
  {
    label: "Telefon persoană de contact",
    value: "contactPerson.phone",
  },
  {
    label: "Status comandă",
    value: "status.name",
  },
];

export const LogFiltersMethods = [
  EAuditAction.CREATE,
  EAuditAction.UPDATE,
  EAuditAction.DELETE,
  EAuditAction.SOFT_DELETE,
  EAuditAction.IMPORT,
  EAuditAction.DUPLICATE,
];

export const LogFiltersStatuses = [
  EAuditStatus.ERROR,
  EAuditStatus.SUCCESS,
  EAuditStatus.INFO,
];

export const ImageExtensions = {
  "image/*": [".png", ".jpeg", ".jpg", ".svg"],
};

export const DocumentExtensions = {
  "application/pdf": [".pdf"],
  "application/msword": [".doc"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ],
  "application/vnd.ms-powerpoint": [".ppt"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
    ".pptx",
  ],
  "text/plain": [".txt"],
  "text/csv": [".csv"],
};

export const DocumentExtensionsArray = [
  ".doc",
  ".docx",
  ".pdf",
  ".xls",
  ".xlsx",
  ".ppt",
  ".pptx",
  ".txt",
  ".csv",
];

export const MessagesAttachmentsOptions = [
  {
    label: Vocabulary.image,
    type: EWhatsAppMessageType.IMAGE,
    icon: <Image />,
    accept: ".png, .jpeg, .jpg",
  },
  {
    label: Vocabulary.document,
    type: EWhatsAppMessageType.DOCUMENT,
    icon: <AttachFile />,
    accept: DocumentExtensionsArray.join(","),
  },
];

export const RuleOptions: { label: string; value: string }[] = [
  {
    label: "< (mai mic)",
    value: "<",
  },
  {
    label: "<= (mai mic sau egal)",
    value: "<=",
  },
  {
    label: "> (mai mare)",
    value: ">",
  },
  {
    label: ">= (mai mare sau egal)",
    value: ">=",
  },
  {
    label: "= (egal)",
    value: "=",
  },
];

export const GenericExcludedFields = [
  "_id",
  "createdAt",
  "updatedAt",
  "deleted_at",
  "__v",
];

export const AlertsTypes = {
  LIVE_LEGISLATION: "liveLegislation",
};

export const ExamTypes = {
  THEORETIC: "Examen Teoretic",
  PRACTIC: "Examen Practic",
};

export const ClientDocumentTypes = {
  psychological: "Aviz psihologic",
  medical: "Fișă medicală",
  criminal: "Certificat de cazier judiciar",
};

export const getMonthName = (monthIndex: number) => {
  return new Intl.DateTimeFormat("ro-RO", { month: "long" }).format(
    new Date(2000, monthIndex, 1)
  );
};

export const getDayName = (dayIndex: number) => {
  // dayIndex: 0 = Sunday, 1 = Monday, etc.
  // Create a date that falls on the desired day (using a known Sunday: 2000-01-02)
  const date = new Date(2000, 0, 2 + dayIndex);
  return new Intl.DateTimeFormat("ro-RO", { weekday: "short" }).format(date);
};

export const OrderSource = {
  ONLINE: "online",
  MANUAL: "manual",
};

export const DRIVING_LESSON_NOTIFICATION_TYPES = {
  LESSON_BOOKING_REQUEST: "lesson_booking_request",
  LESSON_APPROVED_BY_INSTRUCTOR: "lesson_approved_by_instructor",
  LESSON_REJECTED_BY_INSTRUCTOR: "lesson_rejected_by_instructor",
  LESSON_CANCELED_BY_CLIENT: "lesson_canceled_by_client",
  LESSON_CANCELED_BY_INSTRUCTOR: "lesson_canceled_by_instructor",
  LESSON_REMINDER: "lesson_reminder",
};

export const examCategories = {
  A: {
    label: "A, A1, A2, AM",
    icon: <TwoWheeler />,
    maxAllowedWrong: 3,
    totalQuestions: 20,
    totalTime: 20,
  },
  B: {
    label: "B, B1",
    icon: <DirectionsCar />,
    maxAllowedWrong: 4,
    totalQuestions: 26,
    totalTime: 30,
  },
  C: {
    label: "C, C1",
    icon: <LocalShipping />,
    maxAllowedWrong: 4,
    totalQuestions: 26,
    totalTime: 30,
  },
  D: {
    label: "D, D1, Tb, Tv",
    icon: <BusAlert />,
    maxAllowedWrong: 4,
    totalQuestions: 26,
    totalTime: 30,
  },
  E: {
    label: "BE, CE, DE, C1E, D1E",
    icon: <AirlineSeatIndividualSuite />,
    maxAllowedWrong: 2,
    totalQuestions: 11,
    totalTime: 15,
  },
};
